import { useEffect, useState } from 'react';
import { authedFetch } from '../../services/admin.service';
import { TrendingUp, Users, Coins, TrendingDown } from 'lucide-react';

export function AdminRevenuePage() {
  const [overview, setOverview] = useState<any>(null);
  const [byPlan, setByPlan] = useState<any[]>([]);
  const [funnel, setFunnel] = useState<any[]>([]);

  useEffect(() => {
    Promise.all([
      authedFetch<any>('/api/admin/revenue/overview'),
      authedFetch<any>('/api/admin/revenue/by-plan'),
      authedFetch<any>('/api/admin/revenue/funnel'),
    ]).then(([ov, bp, fn]) => { setOverview(ov); setByPlan(bp.byPlan ?? []); setFunnel(fn.funnel ?? []); }).catch(() => {});
  }, []);

  if (!overview) return <div className="courses-loading">Yükleniyor...</div>;
  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          Gelir Analizi <Coins size={28} color="#00AEEF" />
        </h1>
      </header>
      <div className="admin-stats-grid" style={{ marginBottom: 24 }}>
        {[
          { icon: <Users size={22} color="#00AEEF" />, label: 'Aktif Aboneler', value: overview.activeSubscribers },
          { icon: <Coins size={22} color="#10C27A" />, label: 'Aylık Gelir', value: `${overview.monthlyRevenueTry?.toFixed(0)} ₺` },
          { icon: <TrendingUp size={22} color="#7C3AED" />, label: 'Yıllık Gelir', value: `${overview.annualRevenueTry?.toFixed(0)} ₺` },
          { icon: <TrendingDown size={22} color="#EF4444" />, label: 'Churn Rate', value: `%${overview.churnRate}` },
        ].map(c => (
          <div key={c.label} className="admin-stat-card">
            <div className="admin-stat-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {c.icon}
            </div>
            <div className="admin-stat-value">{c.value}</div>
            <div className="admin-stat-label">{c.label}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-2">
        <div className="card">
          <h3 className="parent-section-title">Plan Dağılımı</h3>
          <div className="admin-feature-list">
            {byPlan.map(p => <div key={p.name} className="admin-feature-row"><span>{p.name}</span><span className="admin-feature-stats">{p.count} abone • {p.revenue?.toFixed(0)} ₺/ay</span></div>)}
            {byPlan.length === 0 && <p className="parent-empty-text">Henüz abonelik yok.</p>}
          </div>
        </div>
        <div className="card">
          <h3 className="parent-section-title">Dönüşüm Funnel</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {funnel.map((step, i) => (
              <div key={step.step}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}><span>{step.step}</span><span style={{ color: 'var(--primary-light)' }}>{step.count} kişi (%{step.percent})</span></div>
                <div style={{ height: 8, background: 'var(--dark-lighter)', borderRadius: 4 }}><div style={{ height: '100%', width: `${step.percent}%`, background: `hsl(${240 - i * 30}, 70%, 60%)`, borderRadius: 4 }} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
